import React, { useState, useEffect, Suspense } from "react";

import {
  Paper,
  TableRow,
  TableBody,
  TableContainer,
  TableCell,
  Table,
} from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  DatatablesFooterServerSide,
  TableHeader,
  Title,
  TableCellDefault,
  Loading,
} from "App/Component/ui";

import { STYLE_DEFAULT_MASTER } from "App/constants/theme";

import { useDatatablesServerSide, useDatatables } from "App/hooks";
import {
  getByFilterPembayaranTagihan,
  headCells,
  RESET_STATE_FORM_FILTER,
} from "./helpers";
import {
  defaultDateDisplay,
  defaultToastError,
  formatNumber,
  tipePembayaranName,
} from "App/utils/helpers";

import FormFilterDaftarPembayaranTagihan from "./FormFilterDaftarPembayaranTagihan";
import { LoadingBackdrop } from "components/atoms";

export default function DaftarPembayaranTagihan() {
  const classes = STYLE_DEFAULT_MASTER();

  const [rows, setRows] = useState([]);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    setLoading(true);

    const res = await getByFilterPembayaranTagihan(formFilter, pages, limit);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Suspense fallback={<LoadingBackdrop />}>
      <div className={classes.root}>
        <Title title={"Daftar Pembayaran Tagihan"} />

        <Paper
          className={classes.paper}
          style={{
            padding: "1rem",
          }}>
          <FormFilterDaftarPembayaranTagihan
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            setNewData={setNewData}
          />
          <Loading show={loading} />
          <div className='mt-1'>
            <TableDaftarPembayaranTagihan rows={rows} classes={classes} />
            <DatatablesFooterServerSide
              totalData={totalData}
              pagination={pagination}
              handleChangeLimit={handleChangeLimit}
              onPrevious={onPrevious}
              onNext={onNext}
              currentPage={pagination.page}
              handleClickPageNumber={handleClickPageNumber}
            />
          </div>
        </Paper>
      </div>
    </Suspense>
  );
}

export const TableDaftarPembayaranTagihan = ({ rows, classes }) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  });

  return (
    <TableContainer className='custom-scrollbar'>
      <Table
        className={classes.table}
        aria-labelledby='tableTitle'
        size={"medium"}
        aria-label='enhanced table'>
        <TableHeader
          classes={classes}
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
          rowCount={length}
          headCells={headCells}
        />
        <TableBody>
          {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}>
                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  {index + 1}
                </TableCell>
                <TableCell align='left'>{row?.id}</TableCell>
                <TableCell align='left'>{row?.tagihan_id}</TableCell>
                <TableCell align='left'>
                  {defaultDateDisplay(row?.tanggal_masuk, true)}
                </TableCell>
                <TableCell align='left'>
                  {formatNumber(row?.jumlah_bayar)}
                </TableCell>
                <TableCell align='left'>
                  {tipePembayaranName(row?.tipe_pembayaran_id)}
                </TableCell>
                <TableCell align='left'>{row.nama_kas}</TableCell>

                <TableCell align='left'>{row?.no_kartu}</TableCell>
                <TableCell align='left'>{row?.no_transfer}</TableCell>

                <TableCellDefault row={row} type='custom' />
              </TableRow>
            );
          })}
          {rows.length === 0 && (
            <TableRow>
              <TableCell align='center' colSpan={headCells.length}>
                Tidak ada data
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
